import { createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter, ItemsState } from './items.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getMenuState, (state: MenuState) => state?.items);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedItem = createSelector(getState, (state: ItemsState) => state?.selectedItem);

const getValidAll = createSelector(
  entitySelectors.selectAll,
  asyncActionStateSelectors.getHasError,
  asyncActionStateSelectors.getSuccess,
  (items, hasError, success) => (!hasError && success ? items : null)
);

const getIsEmpty = createSelector(entitySelectors.selectAll, (items) => RA.isNilOrEmpty(items));

export const ItemsSelectors = {
  entitySelectors,
  ...asyncActionStateSelectors,
  getSelectedItem,
  getValidAll,
  getIsEmpty,
};
